import { FC } from 'react';
import { Document } from 'types';

import DocumentRow from './DocumentRow';
import './BoardDocuments.scss';

type Props = {
  documents: Document[];
  hasOptions?: boolean;
  handleDownloadDocument: (index: number) => void; // eslint-disable-line no-unused-vars
  handleRemoveDocument?: (index: number) => void; // eslint-disable-line no-unused-vars
  handleViewDocument?: (index: number) => void; // eslint-disable-line no-unused-vars
  isAdminView?: boolean;
  isSummaryVersion?: boolean;
  textSize?: number;
};

const DocumentsList: FC<Props> = ({
  documents,
  hasOptions = true,
  handleDownloadDocument,
  handleRemoveDocument,
  handleViewDocument,
  isAdminView,
  isSummaryVersion,
  textSize,
}: Props) =>
  documents?.map((document, index) => (
    <DocumentRow
      key={document['_id']}
      index={index}
      document={document}
      hasOptions={hasOptions}
      handleDownloadDocument={handleDownloadDocument}
      handleRemoveDocument={handleRemoveDocument}
      handleViewDocument={handleViewDocument}
      isAdminView={isAdminView}
      isSummaryVersion={isSummaryVersion}
      textSize={textSize}
    />
  ));

export default DocumentsList;
